import React, { useCallback, useMemo } from 'react';
import EditSessionContext from './EditSessionContext';
import useUserPreferences from '../../../data/hooks/useUserPreferences';
const EditSessionStore = ({ children }) => {
    const { loading, preferences: { EDIT_SESSION = false } = {}, updatePreferences, } = useUserPreferences();
    const beginEditSession = useCallback(async () => {
        await updatePreferences({
            EDIT_SESSION: true,
        });
    }, [updatePreferences]);
    const cancelEditSession = useCallback(async () => {
        await updatePreferences({
            EDIT_SESSION: false,
        });
    }, [updatePreferences]);
    const value = useMemo(() => ({
        loading,
        isEditSessionActive: EDIT_SESSION,
        beginEditSession,
        cancelEditSession,
    }), [loading, EDIT_SESSION, beginEditSession, cancelEditSession]);
    return (<EditSessionContext.Provider value={value}>
      {children}
    </EditSessionContext.Provider>);
};
export default EditSessionStore;
